export const initialState = () => ({
    email: null,
    code: null,
    user: null,
});

export const state = initialState();
